import React, { useState } from 'react';
import IconButton from '@material-ui/core/IconButton';

import addCardIcon from 'core/assets/svg/add-card-orange.svg';
import { Label } from 'core/components/label';
import { SmallNotification } from 'core/components/small-notification';
import AddSecondaryPaymentMethodModal from './add-secondary-payment-method-modal';
import useStyles from './secondary-payment-method.styles';

const SecondaryPaymentMethod = () => {
  const classes = useStyles();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <SmallNotification>
        <Label className={classes.note} type="whiteSmall">
          We allow adding alternate payment methods for cases where an immediate charge is needed.
        </Label>
        <IconButton className={classes.actionButton} onClick={() => setIsModalOpen(true)}>
          <div className={classes.button}>
            <img src={addCardIcon} alt="edit" />
            <Label className={classes.action} type="action">
              Add an alternate payment method
            </Label>
          </div>
        </IconButton>
      </SmallNotification>
      {isModalOpen && <AddSecondaryPaymentMethodModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />}
    </>
  );
};

export default SecondaryPaymentMethod;
